<template>
  <svg
    class="SavedPostsFilledIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5625 20.4375L12 15.75L5.4375 20.4375V5.4375C5.4375 4.94022 5.63504 4.46331 5.98667 4.11167C6.33831 3.76004 6.81522 3.5625 7.3125 3.5625H16.6875C17.1848 3.5625 17.6617 3.76004 18.0133 4.11167C18.365 4.46331 18.5625 4.94022 18.5625 5.4375V20.4375Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SavedPostsFilledIcon'
}
</script>

<style lang="scss" scoped>
.SavedPostsFilledIcon {
  @apply fill-current;
}
</style>
